/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockImage as ImageBlockModel } from '@staffino/model';
import { Box, styled } from '@staffino/primitive-controls';

const AutoSizedImage = styled.img({
  maxWidth: '100%',
});

type Props = {
  block: ImageBlockModel;
};
const ImageBlock = ({ block }: Props) => {
  // if (block.size) {
  //   return (
  //     <Image
  //       height={`${block.size}px`}
  //       source={{ uri: block.url }}
  //       cover={!!block.cover}
  //     />
  //   );
  // }
  // no size specified, we just use an image
  return (
    <Box alignItems="center">
      <AutoSizedImage src={block.url} alt="" />
    </Box>
  );
};

export default ImageBlock;
